module.exports = __webpack_public_path__ + "static/4-dd6422674717a5ce466467ef3c394677.jpg";